module.exports = __webpack_public_path__ + "static/work44-394aa034a48b8d4ab4eb966368fbaabc.jpg";